import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { Category } from '../../documents';
import { GeneralDocumentsCommands } from './types';

export class GeneralDocumentsBuildPart extends BaseBuildPart {
    constructor(private readonly generalDocumentsHelperParams: HelperParams,
                parent: BaseBuildPart,
                private readonly generalCommands: GeneralDocumentsCommands) {
        super(generalDocumentsHelperParams, parent, generalCommands);
    }

    public category(category: Category) {
        const [outletCommands] = this.generalCommands as GeneralDocumentsCommands;

        outletCommands.outlets[this.outletName].push(category.categoryId);

        return new BaseBuildPart(this.generalDocumentsHelperParams, this, []);
    }
}